import { render, staticRenderFns } from "./SearchPagination.vue?vue&type=template&id=cfc0fbcc&scoped=true&"
import script from "./SearchPagination.vue?vue&type=script&lang=ts&"
export * from "./SearchPagination.vue?vue&type=script&lang=ts&"
import style0 from "./SearchPagination.vue?vue&type=style&index=0&id=cfc0fbcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc0fbcc",
  null
  
)

export default component.exports